import logo from '../asset/kestren.png';

export default function Logo() {
  return (
    <div className="flex items-center gap-3">
      <img
        src={logo}
        alt="KESTREN Logo"
        className="w-10 h-10 object-contain rounded-lg shadow-md"
      />
      <span className="text-xl font-semibold tracking-tight text-white">
        KESTREN
      </span>
    </div>
  );
}
